import { EventManagerPlugin } from '@angular/platform-browser';
import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, NgZone } from '@angular/core';

const PASSIVE_EVENT_NAMES = new Set([
    'wheel',
    'mousewheel',
    'touchstart',
    'touchmove',
    'touchend',
    'pointermove',
]);

@Injectable()
export class PassiveEventPlugin extends EventManagerPlugin {
    constructor(@Inject(DOCUMENT) doc: Document, private readonly zone: NgZone) {
        super(doc);
    }

    override supports(eventName: string): boolean {
        return PASSIVE_EVENT_NAMES.has(eventName);
    }

    override addEventListener(element: HTMLElement, eventName: string, handler: Function): Function {
        return this.zone.runOutsideAngular(() => {
            const wrappedHandler = handler as EventListener;
            const options: AddEventListenerOptions = { passive: true };

            element.addEventListener(eventName, wrappedHandler, options);

            return () => element.removeEventListener(eventName, wrappedHandler, options);
        });
    }
}
